<script>
export default {
    name: "Hero",
    methods: {
        goPremium() {
            this.$router.push('/subscribe?game=all&period=3m&tier=2')
        },
        openLink(link) {
            if (link) {
                window.open(link, '_blank')
            } else {
                console.error('Нет ссылки')
            }
        }
    }
}
</script>

<template>
    <section class="hero section--hero">
        <div class="hero-content">
            <h1 class="slide-up">
                {{ __('Моды для') }} <span class="h-gradient gradient-animation">GTA:V, Minecraft {{ __('и других игр') }}</span> {{ __('с автоустановкой и приятным интерфейсом') }}
            </h1>
            <div class="btn-container shine">
                <a href="/CloudModsSetup.exe" download class="btn-download slide-up">
                    <svg class="icondnwld" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 16.89C11.84 16.89 11.69 16.865 11.55 16.815C11.41 16.765 11.28 16.68 11.16 16.56L6.84002 12.24C6.60002 12 6.48502 11.72 6.49502 11.4C6.50502 11.08 6.62002 10.8 6.84002 10.56C7.08002 10.32 7.36502 10.195 7.69502 10.185C8.02502 10.175 8.31002 10.29 8.55002 10.53L10.8 12.78V4.2C10.8 3.86 10.915 3.575 11.145 3.345C11.375 3.115 11.66 3 12 3C12.34 3 12.625 3.115 12.855 3.345C13.085 3.575 13.2 3.86 13.2 4.2V12.78L15.45 10.53C15.69 10.29 15.975 10.175 16.305 10.185C16.635 10.195 16.92 10.32 17.16 10.56C17.38 10.8 17.495 11.08 17.505 11.4C17.515 11.72 17.4 12 17.16 12.24L12.84 16.56C12.72 16.68 12.59 16.765 12.45 16.815C12.31 16.865 12.16 16.89 12 16.89ZM4.80002 22.2C4.14002 22.2 3.57502 21.965 3.10502 21.495C2.63502 21.025 2.40002 20.46 2.40002 19.8V17.4C2.40002 17.06 2.51502 16.775 2.74502 16.545C2.97502 16.315 3.26002 16.2 3.60002 16.2C3.94002 16.2 4.22502 16.315 4.45502 16.545C4.68502 16.775 4.80002 17.06 4.80002 17.4V19.8H19.2V17.4C19.2 17.06 19.315 16.775 19.545 16.545C19.775 16.315 20.06 16.2 20.4 16.2C20.74 16.2 21.025 16.315 21.255 16.545C21.485 16.775 21.6 17.06 21.6 17.4V19.8C21.6 20.46 21.365 21.025 20.895 21.495C20.425 21.965 19.86 22.2 19.2 22.2H4.80002Z" fill="white"/>
                    </svg>
                    {{__('Скачать бесплатно')}}
                </a>
                <div @click="goPremium" class="btn-download mobile slide-up">
                    <svg class="mobile_icon" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99983 4.09998C9.21798 4.09998 9.42187 4.20785 9.54341 4.38763L12.0176 8.04729L15.0558 4.65327C15.2516 4.43454 15.5707 4.37271 15.8351 4.50225C16.0995 4.63179 16.2439 4.92075 16.1878 5.20793L14.4296 14.2102C14.3804 14.4622 14.2835 14.695 14.1493 14.9C13.2037 13.2945 11.1698 12.184 8.81322 12.184C6.61516 12.184 4.69782 13.1501 3.68249 14.5828C3.63332 14.4645 3.59536 14.3399 3.57003 14.2102L1.8118 5.20793C1.75571 4.92075 1.90014 4.63179 2.16453 4.50225C2.42893 4.37271 2.74801 4.43454 2.94382 4.65327L5.98201 8.04729L8.45623 4.38763C8.57778 4.20785 8.78161 4.09998 8.99983 4.09998Z" fill="white"/>
                    </svg>
                    {{__('Оформить подписку')}}</div>
                <div @click="goPremium" class="btn-support slide-up">
                    {{__('Оформить подписку')}}
                </div>
                <div @click="openLink('https://discord.gg/MCSkQab2EB')" class="btn-support mobile slide-up">
                    <svg class="mobile_icon" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.273 4.72717L11.6699 7.33022" stroke="white" stroke-width="1.4" stroke-miterlimit="10"/>
                        <path d="M14.273 14.2728L11.6699 11.6698" stroke="white" stroke-width="1.36364" stroke-miterlimit="10"/>
                        <path d="M4.72705 14.2728L7.3301 11.6698" stroke="white" stroke-width="1.36364" stroke-miterlimit="10"/>
                        <path d="M4.72705 4.72717L7.3301 7.33022" stroke="white" stroke-width="1.36364" stroke-miterlimit="10"/>
                        <path d="M9.5 16.25C13.2279 16.25 16.25 13.2279 16.25 9.5C16.25 5.77208 13.2279 2.75 9.5 2.75C5.77208 2.75 2.75 5.77208 2.75 9.5C2.75 13.2279 5.77208 16.25 9.5 16.25Z" stroke="white" stroke-width="1.4" stroke-miterlimit="10" stroke-linecap="square"/>
                        <path d="M11.6693 11.6694C12.8675 10.4712 12.8674 8.52853 11.6692 7.33035C10.471 6.13218 8.52832 6.13221 7.33014 7.33043C6.13196 8.52865 6.13199 10.4713 7.33021 11.6695C8.52844 12.8677 10.4711 12.8676 11.6693 11.6694Z" stroke="white" stroke-width="1.4" stroke-miterlimit="10" stroke-linecap="square"/>
                    </svg>
                    {{__('Тех. поддержка')}}
                </div>
            </div>
        </div>
    </section>
</template>

<style>
    .h-gradient {
        background: linear-gradient(to right, #A157FF 0%, #D2B6FF 29.81%, #B378FF 90.35%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        text-fill-color: transparent;
        background-size: 500% auto;
        transition: 0.25s ease;
        animation: shine 3.5s infinite ease-in-out alternate;
    }

    @keyframes shine {
        0% {
            background-position: 0% 20%;
        }
        100% {
            background-position: 100% 20%;
        }
    }

    .slide-up {
        opacity: 0;
        transform: translateY(30px);
        animation: slideUp 0.8s ease-out forwards;
    }

    @keyframes slideUp {
        0% {
            opacity: 0;
            transform: translateY(30px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .hero {
        width: 100%;

        display: flex;
        justify-content: center;
        text-align: center;

        background-repeat: no-repeat;
        background-position: center;
        user-select: none;
    }

    h1 {
        color: var(--text-primary, #FFF);
        margin: 0;
        font-style: normal;
        font-weight: 700;
        margin-top: 5vw;
    }

    .hero-content {
        position: relative;

        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .btn-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    .btn-download {
        display: inline-flex;
        align-items: center;
        background: var(--color-main);
    }

    .btn-support {
        display: inline-flex;
        align-items: center;
        border: 1px solid #5E5E6D;
    }

    .btn-download, .btn-support {
        color: var(--text-primary);
        font-style: normal;
        font-weight: 600;

        transition: 0.25s ease-in-out;
    }

    .btn-download:hover, .btn-support:hover {
        cursor: pointer;
    }

    .btn-download:hover {
        background: #6143CE;
    }

    .btn-support:hover {
        background: #5E5E6D;
    }

    @media (min-width: 320px) {
        .mobile_icon {
            height: 5.625vw;
        }

        .btn-download {
            display: none;
        }

        .btn-support {
            display: none;
        }

        .hero {
            height: 168.75vw;
            border-radius: 0px 0px 20px 20px;
            background-image: url("@/assets/images/hero320.png");
            background-size: cover;
        }

        h1 {
            text-align: left;
            width: 86.875vw;
            line-height: 120%;
            font-size: 7.1875vw;
            margin-top: 5vw;
        }

        .btn-container {
            position: absolute;
            bottom: 16px;

            flex-direction: column;
            gap: 3.75vw;
        }

        .btn-download.mobile {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 4.375vw;

            background: var(--color-main);
            border-radius: 3.75vw;
            gap: 2.5vw;
            width: 90vw;
            height: 13.4375vw;
        }

        .btn-support.mobile {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 4.375vw;

            border-radius: 3.75vw;
            gap: 2.5vw;
            width: 90vw;
            height: 13.4375vw;
            border: 1px solid #5E5E6D;
        }

        .hero-content {
            margin-top: 66px;
            position: relative;
            width: 454px;

            gap: 30px;
        }

        .icondnwld {
            height: 20px;
            width: 20px;
        }
    }

    @media (min-width: 464px) {
        .btn-download {
            display: flex;
        }

        .btn-support {
            display: flex;
        }

        .btn-download.mobile {
            display: none;
        }

        .btn-support.mobile {
            display: none;
        }

        .hero {
            height: 535px;
            border-radius: 0px 0px 20px 20px;
            background-image: url("@/assets/images/hero464.png");
        }

        h1 {
            text-align: center;
            width: 454px;
            line-height: 120%;
            font-size: 40px;
            letter-spacing: -2.04px;
            margin-top: 0;
        }

        .btn-container {
            position: relative;
            bottom: 0px;
            flex-direction: row;
            gap: 16px;
        }

        .btn-download, .btn-support {
            font-size: 16px;
            line-height: 23px;
            letter-spacing: -0.36px;

            border-radius: 10px;
            gap: 8px;
            padding: 8px 16px;
        }

        .hero-content {
            margin-top: 66px;
            position: relative;
            width: 454px;

            gap: 30px;
        }

        .icondnwld {
            height: 20px;
            width: 20px;
        }
    }

    @media (min-width: 744px) {
        .hero {
            height: 800px;
            border-radius: 0px 0px 20px 20px;
            background-image: url("@/assets/images/hero744.png");
        }

        h1 {
            text-align: center;
            width: 720px;
            line-height: 120%;
            font-size: 52px;
            letter-spacing: -2.04px;
        }

        .btn-container {
            gap: 16px;
        }

        .btn-download, .btn-support {
            font-size: 17px;
            line-height: 23px;
            letter-spacing: -0.36px;

            border-radius: 10px;
            gap: 8px;
            padding: 12px 20px;
        }

        .hero-content {
            margin-top: 101px;
            position: relative;
            width: 744px;

            gap: 40px;
        }
    }

    @media (min-width: 984px) {
        .hero {
            height: 779px;
            border-radius: 0px 0px 20px 20px;
            background-image: url("@/assets/images/hero984.png");
        }

        h1 {
            text-align: center;
            width: 880px;
            line-height: 120%;
            font-size: 56px;
            letter-spacing: -2.04px;
        }

        .btn-container {
            gap: 16px;
        }

        .btn-download, .btn-support {
            font-size: 19px;
            line-height: 23px;
            letter-spacing: -0.36px;

            border-radius: 10px;
            gap: 8px;
            padding: 12px 20px;
        }

        .hero-content {
            margin-top: 100px;
            position: relative;
            width: 984px;

            gap: 40px;
        }
    }

    @media (min-width: 1248px) {
        .hero {
            height: 872px;
            border-radius: 0px 0px 20px 20px;
            background-image: url("@/assets/images/hero1244.png");
            background-size: contain;
        }

        h1 {
            text-align: center;
            width: 972px;
            line-height: 120%;
            font-size: 68px;
            letter-spacing: -2.04px;
        }

        .btn-container {
            gap: 16px;
        }

        .btn-download, .btn-support {
            font-size: 19px;
            line-height: 23px;
            letter-spacing: -0.36px;

            border-radius: 10px;
            gap: 8px;
            padding: 12px 20px;
        }

        .hero-content {
            margin-top: 105px;
            position: relative;
            width: 1248px;

            gap: 20px;
        }
    }
</style>